import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DynamicModule } from 'ng-dynamic-component';
import { combineLatest } from 'rxjs';
import { Product } from 'src/app/classes/utility';
import { DrawerComponent } from 'src/app/components/drawer/drawer.component';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { StoryBlokService } from 'src/app/service/storyblok.service';
import { CallOutComponent } from 'src/app/storyblok/call-out/call-out.component';
import { DisplayTextComponent } from 'src/app/storyblok/display-text/display-text.component';
import { BackInStockComponent } from './components/back-in-stock/back-in-stock.component';
import { ImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { MetaComponent } from './components/meta/meta.component';
import { OkendoComponent } from './components/okendo/okendo.component';
import { ProductService } from './product.service';

@Component({
  selector: 'app-shopify-product',
  standalone: true,
  imports: [
    DynamicModule,
    StoryblokDirective,
    NgIf,
    DrawerComponent,
    BackInStockComponent,
    NgFor,
    ImageGalleryComponent,
    MetaComponent,
    OkendoComponent,
    DisplayTextComponent,
    CallOutComponent,
  ],
  templateUrl: './shopify-product.component.html',
  styleUrl: './shopify-product.component.scss',
})
export class ContentSourceShopifyProductComponent implements OnChanges {
  product!: Product;
  @Input() _editable!: string;
  story: any;
  theme: any;
  components: any;
  _existingLink: string = '';
  constructor(
    private productService: ProductService,
    private storyBlokService: StoryBlokService,
    private route: ActivatedRoute
  ) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });

    combineLatest([
      this.route.data,
      this.storyBlokService.themeObservable,
    ]).subscribe(([product, theme]) => {
      this.theme = structuredClone(theme);
      this.product = product.product;
      try {
        if (!this._existingLink) {
          this._existingLink = structuredClone(
            this.theme.content.personalise[0].action[0].link.cached_url
          );
        }
        this.theme.content.personalise[0].action[0].link.cached_url =
          this._existingLink + '/' + this.product.handle;
      } catch (err) {
        console.log(err);
      }
      this.ngOnChanges();
    });
  }

  async ngOnChanges() {
    if (this.product?.variants) {
      this.productService.variantSubject.next(this.product.variants[0]);
      this.story = await this.storyBlokService
        .getStory(
          'products/' +
            (this.product.metafields?.storyblok?.uid !== undefined
              ? this.product.metafields?.storyblok?.uid
              : this.product.handle),
          {}
        )
        .then((data) => data.story)
        .catch((err) => {});
    }
  }
}
